import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useStore } from 'react-redux';
import QAMobileSideMenu from '../home/sidemenu/QAMobileSideMenu';
import InstaMobileMenu from '../home/sidemenu/InstaMobileMenu';
import StudentMobileMenu from '../home/sidemenu/StudentMobileMenu';
const MobileSideMenu = (props) => {
    const store = useStore();
    const user = store.getState().app.user.user;
    const [activePath, setActivePath] = useState('/');
    const [accordionActiveKey, setAccordionActiveKey] = useState('null');

    useEffect(() => {
        if (window.location.pathname.includes('users')) {
            setActivePath('/users');
        }
        else if (window.location.pathname.includes('hire-titles')) {
            setActivePath('/hire-titles');
        }
        else if (window.location.pathname.includes('departments')) {
            setActivePath('/departments');
        }
        else if (window.location.pathname.includes('positions')) {
            setActivePath('/positions');
        }
        else if (window.location.pathname.includes('questions')) {
            setActivePath('/questions');
        }
        else if (window.location.pathname.includes('candidates')) {
            setActivePath('/candidates');
        } else {
            setActivePath(window.location.pathname);
        }

    }, [useLocation().pathname]);
    const { t } = useTranslation();
    const handleAccordionToggle = (eventKey) => {
        // if (sizeToggler) {
        setAccordionActiveKey(accordionActiveKey === eventKey ? null : eventKey);
        // }
    };
    return (
        <div className='app-sidemenu-bar'>
            <li className={'app-sidemenu-bar-item ' + (activePath === "/" ? 'active' : '')}>
                <Link to="/" onClick={() => { props.hideSidemenu() }}>
                    <span className='link-container'>
                        <span className="material-symbols-outlined">
                            home
                        </span>
                        <span className='link_title'>
                            {t('home')}
                        </span>
                    </span>
                </Link>
            </li>
            {
                user.role === 'qa' &&
                <QAMobileSideMenu  hideSidemenu={()=> props.hideSidemenu()}/>
            }
            {
                user.role === 'teacher' &&
                <InstaMobileMenu hideSidemenu={()=> props.hideSidemenu()}/>
            }
            {user.role === 'student' &&
                <StudentMobileMenu hideSidemenu={()=> props.hideSidemenu()}/>
            }
            <li className={`app-sidemenu-bar-item ${activePath.includes('notifications') ? 'active' : ''}`}>
                <Link to="/notifications" onClick={() => { props.hideSidemenu() }}>
                    <span className='link-container'>
                        <span className="material-symbols-outlined">
                            notifications
                        </span>
                        <span className='link_title'>
                            {t('notifications')}
                        </span>
                    </span>
                </Link>
            </li>
            {/* <li className={`app-sidemenu-bar-item ${activePath.includes('points') ? 'active' : ''}`}>
                <Accordion activeKey={accordionActiveKey}>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header onClick={() => handleAccordionToggle('1')}>
                            <Link className="link">
                                <img src="/assets/svg/hires.svg" alt="" />
                                Points
                            </Link>
                        </Accordion.Header>
                        <Accordion.Body>
                            <ul>
                                <li>
                                    <Link to="/points/earn-points" onClick={() => { props.hideSidemenu() }} >Earn Points</Link>
                                </li>
                                <li>
                                    <Link to="/points/transaction-report" onClick={() => { props.hideSidemenu() }}>Transaction Report</Link>
                                </li>

                            </ul>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </li> */}

        </div>
    );
}

export default MobileSideMenu;